import { create } from "zustand";
import { builder } from "@builder.io/sdk";

type UsePollenOptionsStoreAction = {
  setPollenOptionsData: () => void;
};

const ctaData = {
  copy: "",
  ctaCopy: "",
  ctaLink: "",
  image: "",
};

const initialState = {
  pollenLowerSidebarCta: ctaData,
  pollenUpperSidebarCta: ctaData,
  pollenSpBanner: {
    headline: "",
    subcopy: "",
    ctaCopy: "",
    ctaLink: "",
    image: "",
  },
} as Queries.builder_PollenOptionsData;

const usePollenOptionsStore = create<
  typeof initialState & UsePollenOptionsStoreAction
>(set => ({
  ...initialState,
  setPollenOptionsData: async () => {
    const res = await builder
      .get("pollen-options", {
        fields: "data",
        options: {
          cachebust: false,
        },
      })
      .toPromise();

    if (res?.data) {
      set({ ...res.data });
    }
  },
}));

export default usePollenOptionsStore;
